import React from 'react';
import { useParams } from 'react-router-dom';
// Components
import { HelmetItem } from '../../components/utils/HelmetItem';
import Navbar from '../../components/nav/Navbar';
import BlogPostPageMainContainer from '../../components/blog/BlogPostPageMainContainer';
import Error404 from '../error/Error404';
// Data
import { tempBlogPosts } from '../../utils/data/BlogData';
import { blogPostAdditionalMeta, blogPostStructuredData } from '../../utils/data/MetaData';

function BlogPostPage() {
  const { slug } = useParams();
  const post = tempBlogPosts.find((item) => item.slug === slug);

  if (!post) return <Error404 />;

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName={post.title}
        desc={post.description}
        keywords={post.tags.join(', ')}
        additionalMeta={blogPostAdditionalMeta(post)}
        structuredData={blogPostStructuredData(post)}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />

          {/* Main page content */}
          <BlogPostPageMainContainer post={post} />
        </div>
      </div>
    </>
  );
}

export default BlogPostPage;
